import React from "react";
import { BodyTyp } from "../Typography/Typography";
import { FontWeightEnum } from "../../types/AppTypes";
import { theme } from "../../constants/StyledComponents";
import { StyledMessageBoxContainer } from "./MessageBox.styled";

type MessageBoxProps = {
  message: string;
  color?: string;
};

export const MessageBox = ({ message, color }: MessageBoxProps) => {
  return (
    <StyledMessageBoxContainer>
      <BodyTyp
        variant="1"
        fontWeight={FontWeightEnum.SEMIBOLD}
        color={color ?? theme.colors.purple}
      >
        {message}
      </BodyTyp>
    </StyledMessageBoxContainer>
  );
};
